export const breakpoint = {
  xs: 400,
  s: 600,
  m: 900,
  l: 1200,
  xl: 1800
}
